export default "__VITE_ASSET__D4uLCSW1__"